<!-- PaginationInfo.vue -->

<script setup>
import { computed } from "vue";

const props = defineProps({
  currentPage: { type: Number, required: true },
  pageSize: { type: Number, required: true },
  totalCount: { type: Number, required: true },
});

const paginationInfo = computed(() => {
  if (props.totalCount === 0) return "";

  const startItem = (props.currentPage - 1) * props.pageSize + 1;
  const endItem = Math.min(props.currentPage * props.pageSize, props.totalCount);

  return `${startItem}-${endItem} de ${props.totalCount}`;
});
</script>

<template>
  <span v-if="paginationInfo" class="pagination-info">
    {{ paginationInfo }}
  </span>
</template>

<style scoped>
.pagination-info {
  padding-top: 2px; 
  font-size: 0.82rem;
  line-height: 1.15;
  white-space: nowrap;
}
</style>
